// CANONICAL COPY (GH #7115). src/constants/obligations/obl-storage-media-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-storage-media-management',
  title: 'Verify storage media management lifecycle',
  description:
    "Confirm that storage media (removable media, backup tapes, disks, and media used to transport or store cardholder data or other sensitive information) are managed throughout their lifecycle — acquisition, classification, labelling, use, transportation, storage and secure disposal — in accordance with the organisation's information classification scheme. Review media inventories, distribution logs and destruction records.",
  category: 'assets',
  scfIds: ['SCF-PHY-010'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Storage media management policy is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
